"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const NoPages = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "25", height: "25", viewBox: "0 0 25 25", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.0294 22.2578L2.84195 2.07031L1.42773 3.48453L3.04719 5.10398C2.82758 5.52097 2.70328 5.99597 2.70328 6.5V18.5C2.70328 20.1569 4.04642 21.5 5.70328 21.5H19.4432L21.6152 23.672L23.0294 22.2578ZM17.4432 19.5L12.4432 14.5H9.70328V12.5H10.4432L9.44321 11.5H7.70328V9.76007L4.70328 6.76007V18.5C4.70328 19.0523 5.15099 19.5 5.70328 19.5H17.4432ZM13.0822 9.5L15.0822 11.5H17.7033V9.5H13.0822ZM20.7033 6.5V17.1211L22.6497 19.0675C22.6849 18.8837 22.7033 18.694 22.7033 18.5V6.5C22.7033 4.84315 21.3601 3.5 19.7033 3.5H7.08218L9.08218 5.5H19.7033C20.2556 5.5 20.7033 5.94772 20.7033 6.5Z",
        fill: "#8790A6"
      }
    )
  );
};
export default NoPages;
